import React, { useEffect } from 'react';
import DialogModal from '../../utils/DialogModal';


const NetworkErrorDialog = ({ open }: { open: boolean }) => {

    return (
        <DialogModal open={open} onClose={() => { }} iconClass={"exclam"} buttonOk={"RETRY"}>
            <>
                <p>
                    Your intern connection was lost! Try checking your wifi or mobile data connection.
                </p>
            </>
        </DialogModal>
    )
}

export default NetworkErrorDialog;
